const PbxxRecord = require('../pbxx_record')

module.exports = class AdRun extends PbxxRecord {
  static get class_name() {
    return 'AdRun'
  }
}
